var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEntryDevice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5H11C10.6 22.5 10.22 22.34 9.94 22.06C9.66 21.78 9.5 21.4 9.5 21V18.75H11V21H20V3H11V5.25H9.5V3C9.5 2.6 9.66 2.22 9.94 1.94C10.22 1.66 10.6 1.5 11 1.5H20C20.4 1.5 20.78 1.66 21.06 1.94C21.34 2.22 21.5 2.6 21.5 3V21C21.5 21.4 21.34 21.78 21.06 22.06C20.78 22.34 20.4 22.5 20 22.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.44 15.44L14.12 12.75H3.5V11.25H14.13L11.45 8.56L12.51 7.5L17.01 12L12.51 16.5L11.45 15.44H11.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEntryDevice);
export default __webpack_public_path__ + "static/media/ic-entry-device.75588404ced202d1630a01a34f5dd198.svg";
export { ForwardRef as ReactComponent };